"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFunction = void 0;

function isFunction(obj) {
  return typeof obj === 'function';
}

exports.isFunction = isFunction;